import { formatResponse } from '@frontend/shared/Util.js';

export async function getPublicQuestionnaireQuestions(typeId, advisorSlug) {
  // Keeping public/private methods separate as they will likely need to diverge further than this at some point
  const queryParams = new URLSearchParams({
    'for_advisor': advisorSlug,
  });
  const browserQueryParams = new URLSearchParams(window.location.search);
  if (browserQueryParams.get('questionnaire_type')) {
    typeId = browserQueryParams.get('questionnaire_type');
  }
  if (typeId === 'vadis>.') {
    typeId = 'vadis';
    console.log('WEIRD VADIS RESOLVE');
  }
  const response = await fetch(`/api/v1/questionnaire/${typeId}/?${queryParams}`);
  return formatResponse(response);
};

export async function getQuestionnaireQuestions(typeId) {
  if (typeId === 'vadis>.') {
    typeId = 'vadis';
    console.log('WEIRD VADIS RESOLVE');
  }
  const response = await fetch(`/api/v1/questionnaire/${typeId}/`);
  return formatResponse(response);
};

export async function postQuestionnaireResponses(typeId, requestPayload, csrfToken) {
  if (typeId === 'vadis>.') {
    typeId = 'vadis';
    console.log('WEIRD VADIS RESOLVE');
  }
  const response = await fetch(`/api/v1/questionnaire/${typeId}/responses/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify(requestPayload),
  });
  return formatResponse(response);
};
